import { storage, STORAGE_KEYS } from '@/shared/lib';

const userPreferences = {
  setIsCheckedViewEcgGuideLineNoti: (isCheckedViewEcgGuideLineNoti: any) => {
    storage.set(STORAGE_KEYS.isCheckedViewEcgGuideLineNoti, isCheckedViewEcgGuideLineNoti);
  },

  isCheckedViewEcgGuideLineNoti: (): any => storage.get(STORAGE_KEYS.isCheckedViewEcgGuideLineNoti),

  setIsCheckedNotiCommonQuestions: (isCheckedNotiCommonQuestions: any) => {
    storage.set(STORAGE_KEYS.isCheckedNotiCommonQuestions, isCheckedNotiCommonQuestions);
  },

  isCheckedNotiCommonQuestions: (): any => storage.get(STORAGE_KEYS.isCheckedNotiCommonQuestions),
};

export default userPreferences;
